// ** Type Imports
import { ApplicationStageType, JourneyLineStepConfigType, JourneyStepType } from 'src/lib/types/discounts'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'

interface DiscountJourneyLineProps {
  isSwitchable: boolean
  config: JourneyLineStepConfigType[] | undefined
  currentStep: JourneyStepType
  setCurrentStep: (clickedStep: JourneyStepType) => void
  currentStepIndex: number
  applicationStage?: ApplicationStageType
}

const DiscountJourneyLine: React.FC<DiscountJourneyLineProps> = ({
  isSwitchable,
  config,
  currentStep,
  setCurrentStep,
  currentStepIndex,
  applicationStage
}) => {
  const handleStepClick = (index: number) => {
    const clickedStep = config?.[index]?.step
    if (typeof clickedStep !== 'undefined' && applicationStage !== 'POST_ORDER_PLACEMENT') {
      setCurrentStep(clickedStep)
    }
  }

  const [currentIndex, setCurrentIndex] = useState<number>(0)

  // If last step is hidden increase the count to 1
  let hiddenStepCount = 0
  config?.forEach(
    (step: JourneyLineStepConfigType) =>
      (hiddenStepCount += Boolean(step?.isHidden) ? (step?.step === 'preview' ? 1 : 0) : 0)
  )

  useEffect(() => {
    if (typeof currentStep === 'undefined') return
    setCurrentIndex(config?.findIndex((step: JourneyLineStepConfigType) => step?.step === currentStep) ?? 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep])

  return (
    <ul className='flex w-full gap-1 mb-2 overflow-scroll scrollbar-hide'>
      {config?.map((step: JourneyLineStepConfigType, index: number) => {
        const isCurrentIndex = index === currentIndex

        return (
          <li
            key={`${step.step}_${index}`}
            className={`flex items-center  ${index !== config.length - 1 ? 'w-full' : ''} ${
              index === config?.length - (1 + hiddenStepCount) ? '' : 'mr-auto'
            } ${index === 0 ? '' : 'ml-auto'} ${step?.isHidden ? 'hidden' : ''}`}
          >
            <div
              key={`${step.step}_${index}`}
              onClick={() => (isSwitchable || index <= currentStepIndex) && handleStepClick(index)}
              className={`cursor-pointer transition-all hover:bg-[#f0f0f0] hover:pl-[0.5] duration-100 ease-in-out flex p-0.5 opacity-100 bg-[#F5F5F5] pl-1
                ${isCurrentIndex ? 'bg-[#f0f0f0]' : ''} items-center gap-1 mr-0.5 rounded-lg`}
            >
              <div
                className={`flex transition-all duration-500 items-center justify-center w-4 h-4 rounded-md
                ${index < currentIndex ? 'bg-primary-dark' : ' bg-white'}`}
              >
                <span
                  className={`transition-all duration-50 ease-in-out text-[10px] w-4 text-center
                  ${
                    index < currentIndex
                      ? 'text-white'
                      : index > currentIndex
                      ? isSwitchable
                        ? 'text-gray-dark'
                        : 'text-[#949494]'
                      : 'text-gray-dark'
                  } 
                  ${isCurrentIndex ? 'font-extrabold' : 'font-semibold'}`}
                >
                  {index + 1}
                </span>
              </div>
              <div className='flex items-center'>
                <span
                  className={`transition-all whitespace-pre duration-50 ease-in-out text-sm leading-4 
                  ${isCurrentIndex ? 'font-medium' : 'font-normal'} ${
                    index > currentIndex ? (isSwitchable ? 'text-coal-dark' : 'text-[#949494]') : 'text-coal-dark'
                  }`}
                >
                  {step?.label}
                </span>
              </div>
            </div>
            <div
              className={`h-0.5 min-w-full transition-all duration-500 ease-in-out
                ${index < currentIndex ? 'bg-primary-dark' : 'bg-[#E0E0E0]'} rounded-sm 
                ${index === config?.length - (1 + hiddenStepCount) ? 'hidden' : ''}`}
            ></div>
          </li>
        )
      })}
    </ul>
  )
}

export default DiscountJourneyLine
